export const reasons = [
  {
    key: '4|1',
    value: 'I received a replacement device',
  },
  {
    key: '4|2',
    value: 'I am canceling all of my services',
  },
  {
    key: '4|3',
    value: 'I am canceling this service',
  },
  {
    key: '4|4',
    value: 'This device isn\'t working properly',
  },
  {
    key: '4|5',
    value: 'I no longer need this device',
  },
];

/*
export const formatFetchNewLabelPayload = data => Object.assign({}, formatReturnPayload(data), {
  packageOverride: 1,
  returnOrderId: data.returnOrderId,
});
*/
export const getIsCancelationRequired = (returnReasons = []) => returnReasons.some(value => value === '4|2' || value === '4|3');

export const XFI_PODS = 'xFi Pods';
export const getIsXfiPodDevice = device => (
  device.deviceType === XFI_PODS || device.type === XFI_PODS
);
export const getHasXfiPods = (devices = []) => (
  devices.some(getIsXfiPodDevice)
);
